import { Divider, Skeleton } from "@mui/material";

export function SingleAvailableFlightOfferSkeleton() {
  return (
    <div className="section-card flex w-full flex-col gap-4">
      <div className="flex w-full items-center justify-between">
        <div className="flex gap-2">
          <Skeleton width={24} height={24} />
          <Skeleton width={100} height={24} />
        </div>

        <Skeleton width={61} height={24} />
      </div>

      <Skeleton width="100%" height={68} />

      <Divider
        sx={{
          borderColor: "var(--color-stroke-neutral-softer)",
        }}
      />

      <div className="flex w-full justify-between gap-2">
        <Skeleton width="30%" height={24} />
        <Skeleton width="30%" height={24} />
      </div>
    </div>
  );
}
